import filters from './dataFilter'

export default {
  agendas: [],

  pagination: {
    count: 0,
    current_page: 1,
    links: [],
    per_page: 5,
    total: 0,
    total_pages: 1
  },

  filters: filters(),

  loading: false,

  searchedBy: [],
  searchedByKeyword: [] // adcionando para teste de filtro no resultados
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/store/state.js